import React from 'react'
import { DataTableWrapper } from './styles'
import { TableRowSelection } from 'antd/lib/table/interface'
import { Table } from 'antd'

interface Props<T> {
  data: T[],
  selectableRows?: boolean,
  selectedData?: React.Key[],
  setSelectedData?: any,
  currentPage?: number,
  pageSize?: number,
  loading?: boolean,
  shouldHideCheckbox?: (row: T) => boolean,
  hideHeader?: boolean,
  children: React.ReactNode[],
  disable?: boolean
  onRow?: any
}

const DataTable = <T extends object>({ // eslint-disable-line
  data,
  selectableRows,
  selectedData,
  setSelectedData,
  currentPage,
  pageSize,
  loading,
  shouldHideCheckbox,
  hideHeader,
  children,
  disable,
  onRow
}: Props<T>) => {
  const rowSelection: TableRowSelection<T> = {
    selectedRowKeys: selectedData,
    hideSelectAll: true,
    getCheckboxProps: (row: T) => ({
      className: shouldHideCheckbox && shouldHideCheckbox(row) ? 'hidden' : ''
    }),
    onChange: (keys) => {
      setSelectedData && setSelectedData(keys)
    }
  }

  const addKeyToData = (data: T[]) => data.map((obj: any) => ({ ...obj, key: obj.key || obj.id }))

  return (
    <DataTableWrapper>
      <Table
        className={selectableRows ? 'rows-selectable' : ''}
        dataSource={addKeyToData(data)}
        rowSelection={selectableRows ? rowSelection : undefined}
        pagination={disable ? false : {
          pageSize: pageSize || 10,
          position: [],
          current: currentPage
        }}
        loading={loading}
        showHeader={hideHeader !== undefined ? !hideHeader : true}
        onRow={onRow}
      >
        {children}
      </Table>
    </DataTableWrapper>
  )
}

export default DataTable
